import { Grid } from "@material-ui/core";
import MeditocInfoField from "../../../utils/MeditocInfoField";
import MeditocModal from "../../../utils/MeditocModal";
import { useCallCenter } from "../../../../context/CallCenterContext";

export default function DetalleHistoriaClinica() {
    const { historiaClinica, modalOpenDetalleHistoriaClinica, handleOpenDetalleHistorialClinico } = useCallCenter();

    return (
        <MeditocModal
            title="Detalle de historia clínica"
            open={modalOpenDetalleHistoriaClinica}
            setopen={handleOpenDetalleHistorialClinico}
            // disableBackdropClick={false}
            disableEscapeKeyDown
            okmessage="Cerrar detalle"
            disableScrollLock
            hideBackdrop
            size="small"
            hidecancel
            level={3}
        >
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <MeditocInfoField label="Peso:" value={historiaClinica.fPeso} />
                </Grid>
                <Grid item xs={12}>
                    <MeditocInfoField label="Altura:" value={historiaClinica.fAltura} />
                </Grid>
                <Grid item xs={12}>
                    <MeditocInfoField label="Alergias:" value={historiaClinica.sAlergias} />
                </Grid>
                <Grid item xs={12}>
                    <MeditocInfoField label="Síntomas:" value={historiaClinica.sSintomas} />
                </Grid>
                <Grid item xs={12}>
                    <MeditocInfoField label="Diagnóstico:" value={historiaClinica.sDiagnostico} />
                </Grid>
                <Grid item xs={12}>
                    <MeditocInfoField label="Tratamiento:" value={historiaClinica.sTratamiento} />
                </Grid>
                <Grid item xs={12}>
                    <MeditocInfoField label="Observaciones y comentarios:" value={historiaClinica.sComentarios} />
                </Grid>
                <Grid item xs={12}>
                    <MeditocInfoField label="Inicio de consulta:" value={historiaClinica.sFechaConsultaInicio} />
                </Grid>
                <Grid item xs={12}>
                    <MeditocInfoField label="Fin de consulta:" value={historiaClinica.sFechaConsultaFin} />
                </Grid>
                <Grid item xs={12}>
                    <MeditocInfoField label="Duración de consulta:" value={historiaClinica.sDuracionConsulta} />
                </Grid>
            </Grid>
        </MeditocModal>
    );
}
